import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export const propertyName2Comment: Record<types.NetSuiteInventoryLocationsPropertyName, string> = {
  internalId: 'internalId',
  name: 'name'
};



export const propertyName2Data: Record<types.NetSuiteInventoryLocationsPropertyName, ImportCsvModal.IFormatTypeData> = {
  internalId: {
    example: "188",
    properFormat: "",
    fnValidate: () => true
  },
  name: {
    example: "AAA Express - Neighborhood Beverage Co.",
    properFormat: "",
    fnValidate: () => true
  }
};



export const columnDefs = [
  {
    id: 'Internal ID',
    label: 'Internal ID',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Name',
    label: 'Name',
    isRequired: true,
    formatType: undefined
  }
];
